var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-container"},[_c('div',{staticClass:"skeleton-container__box"},_vm._l((_vm.lineCount),function(loading,index){return _c('div',{key:index,staticClass:"gradient element"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }